import { useEffect } from 'react'
import { Navigate, Outlet, Route, Routes, useParams } from 'react-router-dom'
import { Settings } from '../../../modules/accounts/components/settings/Settings'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { Overview } from '../../../modules/accounts/components/Overview'
import { AccountHeader } from '../../../modules/accounts/AccountHeader'
import { QUERIES, isNotEmpty } from '../../../../_metronic/helpers'
import { useQuery } from 'react-query'
import { getResellerById } from '../resellers-list/core/_requests'
import { useListView } from '../resellers-list/core/ListViewProvider'
import { ResellerView } from './ResellerView'
import { ResellerSettings } from './ResellerSettings'
import { ResellerAccountHeader } from './ResellerAccountHeader'

const ResellerViewPage = () => {
    const params = useParams();
    // alert(params.id)
  const enabledQuery: boolean = isNotEmpty(params.id)
  const {
    isLoading,
    data: reseller,
    error,
  } = useQuery(
    `${QUERIES.RESELLERS_LIST}-reseller-${params.id}`,
    () => {
      return getResellerById(params.id)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {

        console.error(err)
      },
    }
    )

    const accountBreadCrumbs: Array<PageLink> = [
        {
            title: 'Account',
            path: '/admin/pages/resellers/overview',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ]
    return (
        
       <Routes>
         <Route
         path='*'
            element={
                <>
                    <ResellerAccountHeader isResellerLoading={isLoading} reseller={reseller}/>
                    <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                    <Outlet />
                </>
            }
        >
            <Route
                path='view'
                element={
                    <>
                        <ResellerView isResellerLoading={isLoading} reseller = {reseller} />
                    </>
                }
            />
            <Route
                path='settings'
                element={
                    <>
                        <ResellerSettings isResellerLoading={isLoading} reseller = {reseller} />
                    </>
                }
            />
            {/* <Route index element={<Navigate to='/admin/pages/resellers/overview' />} /> */}
        </Route>
       </Routes>
    )
}

export { ResellerViewPage }
